import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { PERMISSIONS } from "router/permissions";
import { Grid } from '@material-ui/core';
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useRuleValidator } from "hooks/useRuleValidator";
const unitTypeSelect = [
  {
    value: 'PORTATIL',
    label: 'PORTATIL'
  },
  {
    value: 'ESTACIONARIO',
    label: 'ESTACIONARIO'
  },
  {
    value: 'ESTACION',
    label: 'ESTACION'
  }
]

export const UnitTypeComponent = ({
  state,
  dispatchAction = () => null
}) => {
  const dispatch = useDispatch();
  const [MapUnitTypes, setMapUnitTypes] = useState(unitTypeSelect);
  const { DIGITAL_INVENTORIES_SYNC } = PERMISSIONS;
  const isDigitalInventories = useRuleValidator(DIGITAL_INVENTORIES_SYNC);
  useEffect(() => {
    if (isDigitalInventories) {
      setMapUnitTypes([...unitTypeSelect.filter(unitType => unitType.value !== 'PORTATIL'), { value: 'ALMACEN', label: 'ALMACEN' }])
    }
  }, [])
  const handleAction = (v) => {
    dispatch(dispatchAction('unitType', v.unitType));
  }

  return (
    <Grid item xs={12} sm={4}>
      <AutocompleteComponent
        key={`unit-type-autocomplete`}
        label="Tipo de Unidad"
        name="unitType"
        value={state?.unitType}
        handleValues={handleAction}
        fullWidth
        variant="outlined"
        allLabel='Todos los tipos de unidad'
        options={MapUnitTypes}
        multiple={true}
        enableSelectAll={true}
        size="small"
        limitTags={3}
      />
    </Grid>
  );
};
